import React, { createContext, useEffect, useMemo, useState } from 'react';
import { DemiTableWrapper } from './TableComponents/DemiTableWrapper';
import { IItem } from '../../types/types';

const ITEMS = [
  {
    rowId: {
      value: '',
      styles: 'basis-[80px] py-[20px] flex items-center justify-center border border-bw03',
      type: 'ITEM_ID',
    },
    itemName: {
      value: '',
      styles: 'basis-1/3 px-[12px] py-[20px] border flex items-center justify-start border-bw03',
      type: '',
    },
    itemDesc: {
      value: 'DESC TEST',
      styles: 'basis-1/3 px-[12px] py-[20px] border flex items-center justify-start border-bw03 bg-bw02',
      type: 'ITEM_DESC',
    },
    quantity: {
      value: '',
      styles: 'basis-[90px] flex py-[20px] items-center justify-center border border-bw03',
      type: '',
    },
    itemPrice: {
      value: '',
      styles: 'basis-[124px] flex py-[20px] items-center justify-center border border-bw03',
      type: '',
    },
    actionComponent: {
      value: '',
      styles: ' hover:bg-red01 basis-[48px] flex items-center justify-center border border-bw03',
      type: 'ACTION',
    },
  },
];

interface IServiceItemsContext {
  handleDeleteServiceItem?: (rowId: number) => void;
}

export const ServiceItemsContext = createContext<IServiceItemsContext>({});

export const InvoiceServiceItemSection = () => {
  const [items, setItems] = useState<IItem[]>([]);

  const handleDeleteServiceItem = (rowId: number) => {
    const updatedList = [...items].filter((item: IItem) => item.rowId.value !== rowId);
    setItems(updatedList);
  };

  const contextValue = useMemo(
    () => ({
      handleDeleteServiceItem,
    }),
    [],
  );

  useEffect(() => {
    setItems(ITEMS);
  }, []);

  return (
    <div className='py-[20px] px-[20px] border-b-[4px] border-bw01'>
      <ServiceItemsContext.Provider value={contextValue}>
        <DemiTableWrapper />
      </ServiceItemsContext.Provider>
    </div>
  );
};
